<script setup>
import {ref, onMounted, getCurrentInstance} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SNB from '../../../../../layouts/nav/SNB.vue'
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import jobFairUserService from "@/pages/user/services/jobFair/jobFairUserService";
import _ from "lodash";
import KSASecondaryButton from "@/components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "@/components/ui-components/button/KSAPrimaryButton.vue";
import fileService from "@/services/fileService";
import KSAInputNumber from "@/components/ui-components/input/KSAInputNumber.vue";
import jobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
import moment from "moment/moment";
import KSAInputGeneralPhoneNum from "@/components/ui-components/input/KSAInputGeneralPhoneNum.vue";
import KSAInput from "@/components/ui-components/input/KSAInput.vue";
import mypageUserService from "@/pages/user/services/mypage/mypageUserService";
import { useAlertStore } from '../../../../../stores/alertStore';
const { $alert, $confirm } = useAlertStore();

const route = useRoute()
const router = useRouter()
const loadingStore = usePageLoadingStore()

const globals = getCurrentInstance().appContext.config.globalProperties;
const { $regex, $gb, $fileSize } = globals;

const ojfId = ref(route.query.ojfId || '');
const mode = ref(route.query.mode || '');

const user = ref({});
const residenceAreaRef = ref(null); // 사업장소재지
const ciFileNameSize = ref(null); // 파일명 + 용량
const bizFileNameSize = ref(null); // 파일명 + 용량
const corpFileNameSize = ref(null); // 파일명 + 용량
const createCorpFileNameSize = ref(null); // 파일명 + 용량

onMounted(()=>{
  if(!ojfId) {
    router.push({name: 'MatchingJobFairList'})
  } else {
    loadingStore.loading = true;
    ojfIntvDay();
    retrieveUserInfo();

    _.each(intvDays.value, el => {el.on = false;})
  }
})

const createCorp = ref({
  "ojfId": 0,
  "joinPurpose": "", // 참가 목적
  "intvInYn": "", // 면접 가능 유무
  "intvAbleDay": "", // 면접가능일
  "intvGb": "", // 면접방식
  "fileYn": "", // 회사이력서파일유무
  "corpResumeAttaches": [
    {
      "attachSeq": 0,
      "fileName": "",
      "fileSize": "",
      "fileDir": "",
      "fileOrder": 0,
      "deleteYn": ""
    }
  ], // 회사이력서파일
  "recruitCnt": 0, // 모집인원
  "chargeName": "", // 참가신청 담당자 이름
  "chargeDepart": "", // 참가신청 담당자 부서
  "chargeJob": "", // 참가신청 담당자 직위
  "chargeCompanyNum": "", // 참가신청 담당자 회사 직통번호
  "chargePhoneNum": "", // 참가신청 담당자 휴대전화
  "chargeEmail": "", // 참가신청 담당자 이메일
  "agreePrivacyYn": false,  // 약관동의유무
})

const inputError = ref({
  // 기업 기본 정보
  bizNum: "", // 사업자등록번호
  corpName: "", // 기업명
  ceoName: "", // 대표자명
  residenceArea: "", // 사업장소재지
  bizType: "", // 업종
  industryGb: "", // 산업군
  corpGb: "", // 기업형태
  foundYm: "", // 창립연월
  employeeNumGb: "", // 사원수
  salesAmtGb: "", // 매출액
  corpPublicYn: "", // 상장여부
  corpPublicGb: "", // 상장구분
  ciImg: "", // 로고이미지(CI)
  bizLicense: "", // 사업자등록증
  // 참가 신청 정보
  joinPurpose: "", // 참가목적
  intvAbleDay: "", // 면접일
  intvGb: "", // 면접방식
  fileYn: "", // 회사이력서파일유무
  corpResumeAttaches: "", // 회사이력서파일
  recruitCnt: "", // 모집인원
  // 참가 신청 담당자 정보
  chargeName: "", // 담당자 성명
  chargeDepart: "", // 담당자 부서
  chargeJob: "", // 담당자 직위
  chargeCompanyNum: "", // 담당자 회사 직통번호
  chargePhoneNum: "", // 담당자 휴대전화
  chargeEmail: "", // 담당자 이메일
  agreePrivacyYn: false, // 동의
})

const intvDays = ref([]); // 면접 가능일
const isAllActive = ref(false); // 면접일 전체
const isEtcActive = ref(false); // 면접일 외 일정

// 면접 가능일 조회
const ojfIntvDay = () => {
  loadingStore.loading = true;
  jobFairUserService.ojfIntvDay(ojfId.value)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          if (result !== null && result !== '') {
            const selectedDays = result.split(',').map(d => d.trim());

            intvDays.value = selectedDays.map(day => ({
              label: day,
              on: false
            }));
          }
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 면접 가능일 클릭
const onClickIntvDay = (clickedDay) => {
  inputError.value.intvAbleDay = '';
  isEtcActive.value = false
  createCorp.value.intvInYn = 'Y';

  if (isAllActive.value) {
    // 전체 모드 해제 → 클릭한 날짜만 on
    isAllActive.value = false

    intvDays.value.forEach(day => {
      day.on = (day === clickedDay)
    })
  } else {
    // 전체 상태가 아닐 때는 토글만
    clickedDay.on = !clickedDay.on

    // 날짜 전체가 선택되었는지 확인
    const allSelected = intvDays.value.every(day => day.on)
    isAllActive.value = allSelected
  }
}

// 면접 가능일 전체
const onClickAll = () => {
  inputError.value.intvAbleDay = ''
  if (isAllActive.value) {
    isAllActive.value = false
    isEtcActive.value = false
    createCorp.value.intvInYn = '';

    intvDays.value.forEach(day => {
      day.on = false
    })
  } else {
    isAllActive.value = true
    isEtcActive.value = false
    createCorp.value.intvInYn = 'Y';

    intvDays.value.forEach(day => {
      day.on = true
    })
  }
}

// 면접 가능일 외
const onClickEtc = () => {
  inputError.value.intvAbleDay = ''

  if (isEtcActive.value) {
    isEtcActive.value = false
    createCorp.value.intvInYn = 'Y'
  } else {
    isEtcActive.value = true
    isAllActive.value = false
    createCorp.value.intvInYn = 'N'

    intvDays.value.forEach(day => {
      day.on = false
    })
  }
}

// 상장여부 초기화
const resetCorpPublic = (val) => {
  if (val === 'N') {
    createCorp.value.corpPublicGb = ''
    createCorp.value.corpPublicText = ''
  }
}

// 상장 기타 초기화
const resetCorpPublicText = (val) => {
  if (val === '05') {
    createCorp.value.corpPublicText = ''
  }
}

// 이력서 양식 초기화
const resetFile = (val) => {
  inputError.value.fileYn = ''
  if (val === 'N') {
    createCorp.value.corpResumeAttaches[0].fileName = ''
    createCorp.value.corpResumeAttaches[0].fileDir = ''
    createCorp.value.corpResumeAttaches[0].fileSize = ''
    createCorpFileNameSize.value = ''
  }
}

// 산업군 기타 초기화
const resetIndustryText = (val) => {
  inputError.value.industryGb = ''
  if (val === '06') {
    createCorp.value.industryText = ''
  }
}

// 기업형태 기타 초기화
const resetCorpText = (val) => {
  inputError.value.corpGb = ''
  if (val === '05') {
    createCorp.value.corpText = ''
  }
}

// 사용자 정보 조회
const retrieveUserInfo = () => {
  loadingStore.loading = true;
  mypageUserService.retrieveUserInfo()
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          // await nextTick();
          const result = res.data.result.corporation;
          // console.log('사용자', result);

          // 사업자등록번호
          if(result.bizNum ) {
            const bizNum = result.bizNum;
            if(bizNum) {
              result.bizNum = bizNum.substring(0,3) + '-' + bizNum.substring(3,5) + '-' + bizNum.substring(5);
            }
          }

          // 사업장소재지
          if(result.residenceArea1 && result.residenceArea2) {
            residenceAreaRef.value.initSelectedOption(result.residenceArea1, result.residenceArea2)
          }

          // 창립연월
          if(result.foundYm ) {
            const foundYm = result.foundYm;
            if(foundYm) {
              result.foundYm = foundYm.substring(0,4) + '.' + foundYm.substring(4,6);
            }
          }

          if(result.ciImgName){
            const originFileSize = $fileSize(result.ciImgSize);
            ciFileNameSize.value = result.ciImgName + '  ' + originFileSize;
          }

          if(result.bizLicenseName){
            const originFileSize = $fileSize(result.bizLicenseSize);
            bizFileNameSize.value = result.bizLicenseName + '  ' + originFileSize;
          }

          if(result.corpIntroName){
            const originFileSize = $fileSize(result.corpIntroSize);
            corpFileNameSize.value = result.corpIntroName + '  ' + originFileSize;
          }

          user.value = result;
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}

const clearErrorFocus = () => {
  try {
    document.querySelectorAll('.error-focus').forEach(el => el.classList.remove('error-focus'))
  } catch(e) {}
}

const focusAndScroll = (el) => {
  if (!el) return
  try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }) } catch(e) {}
  try { el.focus && el.focus({ preventScroll: true }) } catch(e) {}
  try { el.classList && el.classList.add('error-focus') } catch(e) {}
}

const highlightFirstError = () => {
  if (inputError.value.bizNum) {
    const el = document.querySelector('input[placeholder*="10자리"]') || document.querySelector('input[placeholder*="숫자"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.corpName) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('기업명'))
    const el = th ? th.parentElement.querySelector('input, .text-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.ceoName) {
    const el = document.querySelector('input[placeholder*="대표명"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.residenceArea) {
    const el = residenceAreaRef.value?.$el || Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('사업장소재지'))?.parentElement.querySelector('.select')
    focusAndScroll(el)
    return
  }
  if (inputError.value.bizType) {
    const el = document.querySelector('input[placeholder*="업종"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.industryGb) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('산업군'))
    const el = th ? th.parentElement.querySelector('input[type="radio"], .check-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.corpGb) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('기업형태'))
    const el = th ? th.parentElement.querySelector('input[type="radio"], .check-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.foundYm) {
    const el = document.querySelector('input[placeholder*="YYYY.MM"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.employeeNumGb) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('사원수'))
    const el = th ? th.parentElement.querySelector('.select') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.salesAmtGb) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('매출액'))
    const el = th ? th.parentElement.querySelector('.select') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.corpPublicYn) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('상장여부'))
    const el = th ? th.parentElement.querySelector('input[type="radio"], .check-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.corpPublicGb) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('상장여부'))
    const row = th ? th.parentElement.nextElementSibling : null
    const el = row ? row.querySelector('input[type="radio"], .check-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.homeUrl) {
    const el = document.querySelector('input[placeholder*="홈페이지 URL"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.ciImg) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('로고이미지'))
    const el = th ? th.parentElement.querySelector('input[placeholder*="파일 선택"], .input.icon') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.bizLicense) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('사업자등록증'))
    const el = th ? th.parentElement.querySelector('input[placeholder*="파일 선택"], .input.icon') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.intvAbleDay) {
    const el = document.querySelector('.category-wrap')
    focusAndScroll(el)
    return
  }
  if (inputError.value.intvGb) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('면접 방식'))
    const el = th ? th.parentElement.querySelector('input[type="radio"], .check-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.fileYn) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('이력서 양식'))
    const el = th ? th.parentElement.querySelector('input[type="radio"], .check-box') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.corpResumeAttaches) {
    const th = Array.from(document.querySelectorAll('th')).find(t => t.textContent.includes('회사 이력서 양식 첨부'))
    const el = th ? th.parentElement.querySelector('input[placeholder*="파일 선택"], .input.icon') : null
    focusAndScroll(el)
    return
  }
  if (inputError.value.recruitCnt) {
    const el = document.querySelector('input[placeholder="0"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.chargeName) {
    const el = document.querySelector('input[placeholder*="성명"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.chargeDepart) {
    const el = document.querySelector('input[placeholder*="부서"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.chargeJob) {
    const el = document.querySelector('input[placeholder*="직위"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.chargeCompanyNum) {
    const el = document.querySelector('input[placeholder*="직통번호"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.chargePhoneNum) {
    const el = document.querySelector('input[placeholder*="휴대폰"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.chargeEmail) {
    const el = document.querySelector('input[placeholder*="이메일"]')
    focusAndScroll(el)
    return
  }
  if (!createCorp.value.agreePrivacyYn) {
    const el = document.querySelector('.terms-wrap') || document.querySelector('.terms-wrap input[type="checkbox"]')
    focusAndScroll(el)
    return
  }
}

// 기업 정보 및 참가 신청 등록
const saveCorp = async () => {
  clearErrorFocus();
  let isInvalid = false;

  // 기본 기본 정보
  // 사업자등록번호
  inputError.value.bizNum = '';

  const bizNum = user.value.bizNum ? user.value.bizNum.replace('-','').replace('-','') : user.value.bizNum;
  if(!bizNum || bizNum.length !== 10) {
    inputError.value.bizNum = !bizNum ? '사업자등록번호를 입력하세요.' : '10자리 숫자를 입력하세요.';
    isInvalid = true;
  }

  // 대표자명, 사업장소재지, 업종
  const { corpName, ceoName, residenceArea1, residenceArea2, bizType } = user.value;
  inputError.value.corpName = '';
  inputError.value.ceoName = '';
  inputError.value.residenceArea = '';
  inputError.value.bizType = '';

  // 기업명
  if(!corpName) {
    inputError.value.corpName = '기업명을 입력하세요.';
    isInvalid = true;
  }

  // 대표자명
  if(!ceoName) {
    inputError.value.ceoName = '대표자명을 입력하세요.';
    isInvalid = true;
  }

  //사업장소재지
  if((residenceArea1 === '' || residenceArea1 === '시/도 선택') ||
      (residenceArea2 === '' || residenceArea2 === '시/구/군 선택') ) {
    inputError.value.residenceArea = (residenceArea1 === '' || residenceArea1 === '시/도 선택') ? '시/도를 선택하세요.' : '시/구/군을 선택하세요.';
    isInvalid = true;
  }

  // 업종
  if(!bizType) {
    inputError.value.bizType = '업종을 입력하세요.';
    isInvalid = true;
  }

  // 산업구분, 기업형태, 창립연월, 사원수(인원구분), 매출액
  const { industryGb, corpGb, employeeNumGb, salesAmtGb } = user.value;
  inputError.value.industryGb = '';
  inputError.value.corpGb = '';
  inputError.value.foundYm = '';
  inputError.value.employeeNumGb = '';
  inputError.value.salesAmtGb = '';


  // 산업군
  let industryText = user.value.industryText;
  if(!industryGb) {
    inputError.value.industryGb = '산업군을 선택하세요.';
    isInvalid = true;
  } else if(industryGb === '06' && !industryText) {
    inputError.value.industryGb = '기타 산업군을 입력하세요.';
    isInvalid = true;
  } else if (industryGb !== '06') {
    industryText = '';
  }

  // 기업형태
  let corpText = user.value.corpText;
  if(!corpGb) {
    inputError.value.corpGb = '기업형태를 선택하세요.';
    isInvalid = true;
  } else if(corpGb === '05' && !corpText) {
    inputError.value.corpGb = '기타 기업형태를 입력하세요.';
    isInvalid = true;
  } else if (corpGb !== '05') {
    corpText = '';
  }

  // 창립연월
  const foundYm = moment(user.value.foundYm.replace('.', '')).format("YYYYMM")
  if(!foundYm) {
    inputError.value.foundYm = '창립연월을 입력하세요.';
    isInvalid = true;
  } else if (foundYm) {
    if(foundYm.length !== 6) {
      inputError.value.foundYm = '기간을 YYYY.MM 형식으로 입력하세요.';
      isInvalid = true;
    } else if(foundYm === 'Invalid date'  // 존재하지 않은 기간
        // || Number(nowYm) < Number(startYm)  // 미래 기간
    ) {
      inputError.value.foundYm = '올바른 기간을 입력하세요.';
      isInvalid = true;
    }
  }

  // 사원수(인원구분)
  if(!employeeNumGb || employeeNumGb === '00') {
    inputError.value.employeeNumGb = '사원수를 선택하세요.';
    isInvalid = true;
  }

  // 매출액
  if(!salesAmtGb || salesAmtGb === '00') {
    inputError.value.salesAmtGb = '매출액을 선택하세요.';
    isInvalid = true;
  }

  // 상장, 홈페이지 url
  const { corpPublicYn, corpPublicGb } = user.value;
  inputError.value.corpPublicYn = '';
  inputError.value.corpPublicGb = '';

  // 상장
  let corpPublicText = user.value.corpPublicText;
  if(!corpPublicYn) {
    inputError.value.corpPublicYn = '상장여부를 선택하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && !corpPublicGb) {
    inputError.value.corpPublicGb = '상장여부를 선택하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && corpPublicGb === '05' && !corpPublicText) {
    inputError.value.corpPublicGb = '기타 상장을 입력하세요.';
    isInvalid = true;
  } else if(corpPublicYn === 'Y' && corpPublicGb !== '05') {
    corpPublicText = '';
  }

  // 로고이미지(CI)
  const { ciImgName, ciImgSize, ciImgDir } = user.value;
  inputError.value.ciImg = '';

  if(!ciImgName || !ciImgSize || !ciImgDir) {
    inputError.value.ciImg = '로고이미지 파일을 선택하세요.';
    isInvalid = true;
  }

  // 사업자등록증
  const { bizLicenseName, bizLicenseSize, bizLicenseDir } = user.value;
  inputError.value.bizLicense = '';

  if(!bizLicenseName || !bizLicenseSize || !bizLicenseDir) {
    inputError.value.bizLicense = '사업자등록증 파일을 선택하세요.';
    isInvalid = true;
  }

  // 참가 신청 정보
  // 참가 목적
  const { joinPurpose } = createCorp.value;
  inputError.value.joinPurpose = '';

  // ella : 참가 목적 숨김 요청 (20250904)
  // if(!joinPurpose) {
  //   inputError.value.joinPurpose = '참가 목적을 입력하세요.';
  //   isInvalid = true;
  // }

  // 면접 가능일
  const intvAbleDay = _.map(_.filter(intvDays.value, {'on': true}), 'label').join(',');

  const { intvInYn } = createCorp.value;
  inputError.value.intvAbleDay = '';

  if(!intvInYn) {
    inputError.value.intvAbleDay = '면접 가능일을 선택하세요.';
    isInvalid = true;
  } else if (intvInYn === 'Y' && !intvAbleDay) {
    inputError.value.intvAbleDay = '면접 가능일을 선택하세요.';
    isInvalid = true;
  }

  // 면접 방식
  const { intvGb } = createCorp.value;
  inputError.value.intvGb = '';

  if(!intvGb) {
    inputError.value.intvGb = '면접 방식을 선택하세요.';
    isInvalid = true;
  }

  // 이력서 양식, 회사 이력서 양식 첨부, 모집인원
  const { fileYn, recruitCnt } = createCorp.value;
  const corpResumeAttaches =  _.filter(createCorp.value.corpResumeAttaches, attach => {
    return attach.fileName !== null && attach.fileName !== '';
  })
  inputError.value.fileYn = '';
  inputError.value.corpResumeAttaches = '';
  inputError.value.recruitCnt = '';

  if(!fileYn) {
    inputError.value.fileYn = '면접 방식을 선택하세요.';
    isInvalid = true;
  } else if(fileYn === 'Y' && !corpResumeAttaches[0]) {
    inputError.value.corpResumeAttaches = '회사 이력서 양식을 첨부해주세요.';
    isInvalid = true;
  }

  // 모집인원
  if(!recruitCnt || recruitCnt === '0') {
    inputError.value.recruitCnt = '모집인원을 입력하세요.';
    isInvalid = true;
  }

  // 참가 신청 담당자 정보
  const { chargeName, chargeDepart, chargeJob, chargeCompanyNum, chargePhoneNum } = createCorp.value;
  inputError.value.chargeName  = '';
  inputError.value.chargeDepart  = '';
  inputError.value.chargeJob  = '';
  inputError.value.chargeCompanyNum  = '';
  inputError.value.chargePhoneNum  = '';
  inputError.value.chargeEmail  = '';

  // 성명
  if(!chargeName) {
    inputError.value.chargeName = '성명을 입력하세요.';
    isInvalid = true;
  }

  // 부서
  if(!chargeDepart) {
    inputError.value.chargeDepart = '부서를 입력하세요.';
    isInvalid = true;
  }

  // 직위
  if(!chargeJob) {
    inputError.value.chargeJob = '직위를 입력하세요.';
    isInvalid = true;
  }

  // 회사 직통번호
  if(!chargeCompanyNum) {
    inputError.value.chargeCompanyNum = '회사 직통번호를 입력하세요.';
    isInvalid = true;
  }
  // 20250924(ella): 회사 직통번호 밸리데이션 제거
  // } else if(!$regex.generalPhoneNum.test(chargeCompanyNum)) {
  //
  //   inputError.value.chargeCompanyNum = '회사 직통번호를 숫자로만 입력하세요.';
  //   isInvalid = true;
  // }

  // 휴대전화
  if(!chargePhoneNum || chargePhoneNum.length !== 13) {
    inputError.value.chargePhoneNum = '휴대폰 번호를 입력하세요.';
    isInvalid = true;
  } else if(!$regex.phoneNum.test(chargePhoneNum)) {
    inputError.value.chargePhoneNum = '휴대폰 번호를 숫자로만 입력하세요.';
    isInvalid = true;
  }

  // 이메일 형식 확인
  const chargeEmail = createCorp.value.chargeEmail.trim()
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  // 이메일
  if(!chargeEmail) {
    inputError.value.chargeEmail = '이메일을 입력하세요.';
    isInvalid = true;
  } else if (!emailRegex.test(chargeEmail)) {
    inputError.value.chargeEmail = '유효한 이메일 형식을 입력하세요.';
    isInvalid = true;
  }

  // 약관 동의
  const agreePrivacyYn = createCorp.value.agreePrivacyYn ? 'Y' : 'N';
  inputError.value.agreePrivacyYn  = false;

  if(isInvalid) {
    // $alert("필수 입력사항을 확인해 주세요.");
    highlightFirstError();
    isInvalid = true;
  } else if(agreePrivacyYn === 'N') {
    $alert("필수 약관을 확인하고 동의해 주세요.");
    highlightFirstError();
    isInvalid = true;
  }

  // 저장 처리
  if(!isInvalid) {
    const ok = await $confirm(["참가 신청을 위해서는 채용공고에 공개할", "공고 등록이 필요합니다.", "등록된 채용공고는", "추후 언제든 수정이 가능합니다."], "채용공고 등록하기", "참가 신청 취소");
    if(!ok) {
      // return -1;
      $alert("참가 신청이 취소되었습니다.");

      if (mode.value === 'openRecruitment') {
        router.push({name: 'MatchingOpenRecruitmentDetail', params:{id: ojfId.value}})
      } else {
        router.push({name: 'MatchingJobFairDetail', params:{id: ojfId.value}})
      }
    } else {
      let paramObj = {
        ojfId: ojfId.value,
        bizNum: user.value.bizNum ? user.value.bizNum.replace('-','').replace('-','') : user.value.bizNum,
        corpName: user.value.corpName,
        ceoName: user.value.ceoName,
        residenceArea1: user.value.residenceArea1,
        residenceArea2: user.value.residenceArea2,
        bizType: user.value.bizType,
        industryGb: user.value.industryGb,
        industryText: industryText,
        corpGb: user.value.corpGb,
        corpText: corpText,
        foundYm: user.value.foundYm ? user.value.foundYm.replace('.','').replace('.','') : user.value.foundYm,
        employeeNumGb: user.value.employeeNumGb,
        salesAmtGb: user.value.salesAmtGb,
        corpPublicYn: user.value.corpPublicYn,
        corpPublicGb: user.value.corpPublicGb,
        corpPublicText: corpPublicText,
        homeUrl: user.value.homeUrl,
        ciImgName: user.value.ciImgName,
        ciImgSize: user.value.ciImgSize,
        ciImgDir: user.value.ciImgDir,
        bizLicenseName: user.value.bizLicenseName,
        bizLicenseSize: user.value.bizLicenseSize,
        bizLicenseDir: user.value.bizLicenseDir,
        corpIntro: user.value.corpIntro,
        corpHistory: user.value.corpHistory,
        corpIntroName: user.value.corpIntroName,
        corpIntroSize: user.value.corpIntroSize,
        corpIntroDir: user.value.corpIntroDir,
        joinPurpose,
        intvInYn,
        intvAbleDay,
        intvGb,
        fileYn,
        corpResumeAttaches,
        recruitCnt,
        chargeName,
        chargeDepart,
        chargeJob,
        chargeCompanyNum,
        chargePhoneNum,
        chargeEmail,
        agreePrivacyYn,
      }

      sessionStorage.setItem('recruitmentData', JSON.stringify(paramObj));

      if (mode.value === 'openRecruitment') {
        router.push({ name: 'MyPageCorpJobNoticeCreat', query : { ojfId: ojfId.value, mode : 'openRecruitment' }});
      } else {
        router.push({ name: 'MyPageCorpJobNoticeCreat', query : { ojfId: ojfId.value, mode : 'corpRecruitmentHall' }});
      }
    }
  }
}

const clickCancel = async (ojfId) => {
  $alert("참가 신청이 취소되었습니다.");
  if (mode.value === "openRecruitment") {
    router.push({name: 'MatchingOpenRecruitmentDetail', params:{id: ojfId}})
  } else {
    router.push({name: 'MatchingJobFairDetail', params:{id: ojfId}})
  }
}

// 특수문자 작성 안됨
const filterText = (value) => {
  return value.replace(/[^a-zA-Z0-9ㄱ-ㅎ가-힣\s]/g, ''); // 특수문자 제거
}

const onInputChange = (event, key) => {
  const filteredValue = filterText(event.target.value).slice(0, 200); // 글자수 제한 200자

  // 필터링된 값 적용
  createCorp.value[key] = filteredValue;

  // 유효성 체크
  if (!filteredValue) {
    inputError.value[key] = '참가 목적을 입력하세요.';
  } else if (filteredValue.length > 200) {
    inputError.value[key] = '참가 목적은 최대 200자까지 입력하세요.';
  } else {
    inputError.value[key] = ''; // 유효성 통과시 에러 메시지 초기화
  }
}

// 사업자등록번호
const bizNumInput = ref('')

const formatBizNum = (event) => {
  inputError.value.bizNum = ''
  // 숫자만 필터링
  bizNumInput.value = event.target.value.replace(/\D/g, '').slice(0, 6)

  // YYYY.MM 형식으로 포맷팅
  if (bizNumInput.value.length >= 5) {
    createCorp.bizNum = `${bizNumInput.value.slice(0, 3)}-${bizNumInput.value.slice(0,2)}-${bizNumInput.value.slice(5)}`
  } else {
    createCorp.bizNum = bizNumInput.value
  }
}

const validateText = (key) => {
  if (key === 'corpName') {
    if (user.value.corpName.trim() === '') {
      inputError.value.corpName = '기업명을 입력하세요.';
    } else if (user.value.corpName.length > 500) {
      inputError.value.corpName = '기업명은 최대 500자까지 입력하세요.';
    } else {
      inputError.value.corpName = '';
    }
  } else if (key === 'ceoName') {
    if (user.value.ceoName.trim() === '') {
      inputError.value.ceoName = '대표자명을 입력하세요.';
    } else if (user.value.ceoName.length > 50) {
      inputError.value.ceoName = '대표자명은 최대 50자까지 입력하세요.';
    } else {
      inputError.value.ceoName = '';
    }
  } else if (key === 'bizType') {
    if (user.value.bizType.trim() === '') {
      inputError.value.bizType = '업종을 입력하세요.';
    } else if (user.value.bizType.length > 100) {
      inputError.value.bizType = '업종은 최대 100자까지 입력하세요.';
    } else {
      inputError.value.bizType = '';
    }
  } else if (key === 'foundYm') {
    inputError.value.foundYm = '' ? '창립연월을 입력하세요.' : '';
  } else if (key === 'homeUrl') {
    if (user.value.homeUrl.length > 200) {
      inputError.value.homeUrl = '홈페이지 URL은 최대 200자까지 입력하세요.';
    } else {
      inputError.value.homeUrl = '';
    }
  } else if (key === 'corpHistory') {
    // console.log(user.value.corpHistory, '1111')
    // if (user.value.corpHistory.length > 4000) {
    //   console.log(user.value.corpHistory, '1111')
    //   inputError.value.corpHistory = '주요 연혁은 최대 4000자까지 입력하세요.';
    // } else {
    //   console.log(user.value.corpHistory, '1111')
    //   inputError.value.corpHistory = '';
    // }
  } else if (key === 'recruitCnt') {
    inputError.value.recruitCnt = '' ? '모집인원을 입력하세요.' : '';
  } else if (key === 'chargeName') {
    if (createCorp.value.chargeName.trim() === '') {
      inputError.value.chargeName = '성명을 입력하세요.';
    } else if (createCorp.value.chargeName.length > 10) {
      inputError.value.chargeName = '성명은 최대 10자까지 입력하세요.';
    } else {
      inputError.value.chargeName = '';
    }
  } else if (key === 'chargeDepart') {
    if (createCorp.value.chargeDepart.trim() === '') {
      inputError.value.chargeDepart = '부서를 입력하세요.';
    } else if (createCorp.value.chargeDepart.length > 10) {
      inputError.value.chargeDepart = '부서는 최대 10자까지 입력하세요.';
    } else {
      inputError.value.chargeDepart = '';
    }
  } else if (key === 'chargeJob') {
    if (createCorp.value.chargeJob.trim() === '') {
      inputError.value.chargeJob = '직위를 입력하세요.';
    } else if (createCorp.value.chargeJob.length > 10) {
      inputError.value.chargeJob = '직위는 최대 10자까지 입력하세요.';
    } else {
      inputError.value.chargeJob = '';
    }
  } else if (key === 'chargeCompanyNum') {
    inputError.value.chargeCompanyNum = '' ? '회사 직통번호를 입력하세요.' : '';
  } else if (key === 'chargePhoneNum') {
    inputError.value.chargePhoneNum = '' ? '휴대폰 번호를 입력하세요.' : '';
  } else if (key === 'chargeEmail') {
    const email = createCorp.value.chargeEmail.trim()
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (email === '') {
      inputError.value.chargeEmail = '이메일을 입력하세요.'
    } else if (email.length > 50) {
      inputError.value.chargeEmail = '이메일은 최대 50자까지 입력하세요.'
    } else if (!emailRegex.test(email)) {
      inputError.value.chargeEmail = '유효한 이메일 형식을 입력하세요.'
    } else {
      inputError.value.chargeEmail = ''
    }
  }
}

const optionData = (key) => {
  if (key === 'intvGb') {
    inputError.value.intvGb = '' ? '면접 방식을 선택하세요.' : '';
  }
}

// 사업장소재지
const onSelectedArea1Option = (option) => {
  user.value.residenceArea1 = option;
  inputError.value.residenceArea = '';
}

const onSelectedArea2Option = (option) => {
  user.value.residenceArea2 = option;
  inputError.value.residenceArea = '';
}

// 창립연월
const rawInput = ref('')

const formatDate = (event) => {
  inputError.value.foundYm = ''
  // 숫자만 필터링
  rawInput.value = event.target.value.replace(/\D/g, '').slice(0, 6)

  // YYYY.MM 형식으로 포맷팅
  if (rawInput.value.length >= 5) {
    user.value.foundYm = `${rawInput.value.slice(0, 4)}.${rawInput.value.slice(4)}`
  } else {
    user.value.foundYm = rawInput.value
  }
}


// 매출액
const clickSalesAmtGb = (option) => {
  user.value.salesAmtGb = option.value;
  inputError.value.salesAmtGb = '';
}


// 로고이미지(CI) 업로드
const uploadFileCiImg = (createCorp) => {
  inputError.value.ciImg = ''
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'public',
      folder: 'ciImg',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            createCorp.ciImgName = result.originalFilename;
            createCorp.ciImgSize = result.fileSize;
            createCorp.ciImgDir = result.blobUrl;
            const upFileSize = $fileSize(result.fileSize);
            ciFileNameSize.value = result.originalFilename + '  ' + upFileSize;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 로고이미지(CI) 삭제
const removeFileCiImg = (createCorp) => {
  createCorp.ciImgName = '';
  createCorp.ciImgSize = '';
  createCorp.ciImgDir = '';
  inputError.value.ciImg = '';
  ciFileNameSize.value = '';
}

// 사업자등록증 업로드
const uploadFileBizLicense = (createCorp) => {
  inputError.value.bizLicense = ''
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'private',
      folder: 'bizLicense',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            createCorp.bizLicenseName = result.originalFilename;
            createCorp.bizLicenseSize = result.fileSize;
            createCorp.bizLicenseDir = result.blobUrl;
            const upFileSize = $fileSize(result.fileSize);
            bizFileNameSize.value = result.originalFilename + '  ' + upFileSize;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 사업자등록증 삭제
const removeFileBizLicense = (createCorp) => {
  createCorp.bizLicenseName = '';
  createCorp.bizLicenseSize = '';
  createCorp.bizLicenseDir = '';
  inputError.value.bizLicense = '';
  bizFileNameSize.value = '';
}

// 기업소개서 업로드
const uploadFileCorpIntro = (createCorp) => {
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'private',
      folder: 'corpIntro',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            createCorp.corpIntroName = result.originalFilename;
            createCorp.corpIntroSize = result.fileSize;
            createCorp.corpIntroDir = result.blobUrl;
            const upFileSize = $fileSize(result.fileSize);
            corpFileNameSize.value = result.originalFilename + '  ' + upFileSize;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 기업소개서 삭제
const removeFileCorpIntro = (createCorp) => {
  createCorp.corpIntroName = '';
  createCorp.corpIntroSize = '';
  createCorp.corpIntroDir = '';
  corpFileNameSize.value = '';
}

// 회사 이력서 양식 업로드
const uploadFileCorpResume = () => {
  const input = document.createElement('input');
  input.type= 'file';
  input.click();

  input.addEventListener('change', function(event){
    // console.log(event.target.files);
    const file = event.target.files[0];

    let paramObj = {
      container: 'private',
      folder: 'corpResumeAttaches',
      file,
    }
    fileService.uploadFile(paramObj)
        .then((res) => {
          // console.log(res);
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            createCorp.value.corpResumeAttaches[0].fileName = result.originalFilename;
            createCorp.value.corpResumeAttaches[0].fileSize = result.fileSize;
            createCorp.value.corpResumeAttaches[0].fileDir = result.blobUrl;
            const upFileSize = $fileSize(result.fileSize);
            createCorpFileNameSize.value = result.originalFilename + '  ' + upFileSize;
          }
        }).catch( (error) =>  {
      console.log(error);
    });
  });
}

// 회사 이력서 양식 삭제
const removeFileCorpResume = () => {
  createCorp.value.corpResumeAttaches[0].fileName = '';
  createCorp.value.corpResumeAttaches[0].fileSize = '';
  createCorp.value.corpResumeAttaches[0].fileDir = '';
  createCorpFileNameSize.value = '';
  inputError.value.corpResumeAttaches = '';
}

</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <!-- S : 강의 상세-->
        <div class="content" :style="{width:'100% !important'}">
          <div class="lecture-wrap">
            <div class="sub-title grid space-between">
              <h3>기업 정보 등록 및 참가 신청</h3>
            </div>
            <p class="mt-xs">{{ mode === 'openRecruitment' ? '기업공채관' : '채용박람회' }} 참가를 위한 기업 정보 등록과 신청서를 작성하세요.</p>
            <p class="mt-xs">기업정보가 틀릴 경우 참가 신청이 반려처리 될 수 있습니다.(<span class="red">*</span>표시는 필수 입력사항입니다.)</p>
            <div class="lecture-detail">
              <!-- s : 기업 기본 정보 -->
              <div class="table-form mt-sm">
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">기업 기본 정보</th>
                  </tr>
                  <tr>
                    <th class="mark">사업자등록번호</th>
                    <td>
                      <KSAInput class="text-box" @input="formatBizNum" v-model="user.bizNum" maxLength="15" placeholder="10자리 숫자 입력" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.bizNum }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">기업명</th>
                    <td>
                      <KSAInput class="text-box" @input="validateText('corpName')" maxLength="500" v-model="user.corpName" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpName }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">대표자명</th>
                    <td>
                      <KSAInput class="text-box" v-model="user.ceoName" @input="validateText('ceoName')" maxLength="50" placeholder="대표명을 입력하세요." />
                      <div>
                        <small style="color:#E71414;">{{ inputError.ceoName }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">사업장소재지</th>
                    <td>
                      <KSASelectResidenceArea ref="residenceAreaRef" class="select" @selectOption1="onSelectedArea1Option" @selectOption2="onSelectedArea2Option"/>
                      <div>
                        <small style="color:#E71414;">{{ inputError.residenceArea }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">업종</th>
                    <td>
                      <KSAInput class="text-box" v-model="user.bizType" @input="validateText('bizType')" maxLength="50" placeholder="업종을 입력하세요." />
                      <div>
                        <small style="color:#E71414;">{{ inputError.bizType }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">산업군</th>
                    <td>
                      <template v-for="option in $gb.INDUSTRY_GB">
                        <KSARadioButton class="check-box mr-md" name="industryGb" :label="option.label" v-model="user.industryGb" :value="option.value" @change="resetIndustryText(option.value)" />
                        <div class="etc-box" v-if="option.label === '기타' && user.industryGb == option.value" >
                          <KSAInput class="text-box" v-model="user.industryText" placeholder="기타 산업군을 입력하세요." />
                        </div>
                      </template>
                      <div>
                        <small style="color:#E71414;">{{ inputError.industryGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">기업형태</th>
                    <td>
                      <template v-for="option in $gb.CORP_GB">
                        <KSARadioButton class="check-box mr-sm" name="corpGb" :label="option.label" v-model="user.corpGb" :value="option.value" @change="resetCorpText(option.value)"/>
                        <div class="etc-box" v-if="option.label === '기타' && user.corpGb == option.value" >
                          <KSAInput class="text-box" v-model="user.corpText" placeholder="기타 기업형태를 입력하세요." />
                        </div>
                      </template>
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">창립연월</th>
                    <td>
                      <KSAInput class="text-box" @input="formatDate" v-model="user.foundYm" placeholder="YYYY.MM" maxlength="7" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.foundYm }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">사원수</th>
                    <td>
                      <KSASelect v-if="!user.employeeNumGb" class="select" v-model="user.employeeNumGb" :options="[{ label: '선택', value: '00' }, ...$gb['EMPLOYEE_NUM_GB']]" />
                      <KSASelect v-else class="select" v-model="user.employeeNumGb" :options="$gb['EMPLOYEE_NUM_GB']" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.employeeNumGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">매출액</th>
                    <td>
                      <KSASelect v-if="!user.salesAmtGb" class="select" :options="[{ label: '선택', value: '' }, ...$gb['SALES_AMT_GB']]" @selectOption="clickSalesAmtGb"/>
                      <KSASelect v-else class="select" :options="$gb['SALES_AMT_GB']" @selectOption="clickSalesAmtGb"/>
                      <div>
                        <small style="color:#E71414;">{{ inputError.salesAmtGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark" rowspan="2">상장여부</th>
                    <td>
                      <KSARadioButton class="check-box mr-lg" label="상장" v-model="user.corpPublicYn" value="Y" @change="resetCorpPublic('Y')" />
                      <KSARadioButton class="check-box mr-lg" label="비상장" v-model="user.corpPublicYn" value="N" @change="resetCorpPublic('N')" />
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpPublicYn }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td v-if="user.corpPublicYn === 'Y'">
                      <template v-for="option in $gb.CORP_PUBLIC_GB">
                        <KSARadioButton class="check-box mr-sm" name="corpPublicGb" :label="option.label" v-model="user.corpPublicGb" :value="option.value" @change="resetCorpPublicText(option.value)" />
                        <div class="etc-box" v-if="option.label === '기타' && user.corpPublicGb == option.value" >
                          <KSAInput class="text-box" v-model="user.corpPublicText" placeholder="기타 상장을 입력하세요." />
                        </div>
                      </template>
                      <div>
                        <small style="color:#E71414;">{{ inputError.corpPublicGb }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>홈페이지 URL</th>
                    <td>
                      <KSAInput class="text-box" v-model="user.homeUrl" @input="validateText('homeUrl')" maxLength="200" placeholder="홈페이지 URL을 입력하세요." />
                      <div>
                        <small style="color:#E71414;">{{ inputError.homeUrl }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">로고이미지(CI)</th>
                    <td class="text-box">
                      <div class="grid file">
                        <KSAPrimaryButton text="파일 선택" @click="uploadFileCiImg(user)" />
                        <KSAInput class="input icon" v-model="ciFileNameSize" @input="validateText('ciImg')" placeholder="파일 선택(1200px X 265px, 300DPI 이미지를 권장합니다.)" disabled />
                        <button class="delete" @click="removeFileCiImg(user)"><i></i></button>
                      </div>
                      <small>최대 200MB 까지 첨부 가능</small>
                      <div>
                        <small style="color:#E71414;">{{ inputError.ciImg }}</small>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">사업자등록증</th>
                    <td class="text-box">
                      <div class="grid file">
                        <KSAPrimaryButton text="파일 선택" @click="uploadFileBizLicense(user)" />
                        <KSAInput class="input icon" v-model="bizFileNameSize" placeholder="파일 선택" disabled />
                        <button class="delete" @click="removeFileBizLicense(user)"><i></i></button>
                      </div>
                      <small>최대 200MB 까지 첨부 가능</small>
                      <div>
                        <small style="color:#E71414;">{{ inputError.bizLicense }}</small>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- e : 기업 기본 정보 -->
              <!-- s : 기업 추가 정보 -->
              <div class="table-form mt-sm">
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">기업 추가 정보</th>
                  </tr>
                  <tr>
                    <th>기업 소개</th>
                    <td>
                      <KSACKEditor ref="editorRef" v-if="user.corpIntro !== undefined" v-model="user.corpIntro" />
                    </td>
                  </tr>
                  <tr>
                    <th>주요 연혁</th>
                    <td>
                      <KSACKEditor ref="editorRef" v-if="user.corpHistory !== undefined" v-model="user.corpHistory" @update:modelValue="validateText('corpHistory')" />
                      <!-- <p>
                        <small style="color:#E71414;">{{ inputError.corpHistory }}</small>
                      </p> -->
                    </td>
                  </tr>
                  <tr>
                    <th>기업 소개서</th>
                    <td class="text-box">
                      <div class="grid file">
                        <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpIntro(user)" />
                        <KSAInput class="input icon" v-model="corpFileNameSize" placeholder="파일 선택" disabled />
                        <button class="delete" @click="removeFileCorpIntro(user)"><i></i></button>
                      </div>
                      <small>최대 200MB 까지 첨부 가능</small>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- e : 기업 추가 정보 -->
              <!-- s : 참가 신청 정보 -->
              <div class="table-form mt-sm">
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">참가 신청 정보</th>
                  </tr>
                  <!-- ella : 참가 목적 숨김 요청 (20250904) -->
<!--                  <tr>-->
<!--                    <th class="mark">참가 목적</th>-->
<!--                    <td>-->
<!--                      <KSAInput v-model="createCorp.joinPurpose" @input="(event) => onInputChange(event, 'joinPurpose')" placeholder="ex) 효율적인 인재 채용, 기업 홍보 및 인지도 확대, 직무에 맞는 인재 발굴, 채용 횽보, 대규모 인채 풀 확보 등" />-->
<!--                      <p>-->
<!--                        <small style="color:#E71414;">{{ inputError.joinPurpose }}</small>-->
<!--                      </p>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr>
                    <th rowspan="2">
                      <span class="mark">면접 가능일</span>
                    </th>
                    <td>
                      <ul class="grid category-wrap">
                        <li :class="{'active': isAllActive}" @click="onClickAll">전체 일정 가능</li>
                        <li :class="{'active': day.on, 'disabled': isAllActive}" v-for="day in intvDays" @click="onClickIntvDay(day)">
                          {{ day.label }}
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ul class="grid category-wrap">
                        <li :class="{'active': isEtcActive}" @click="onClickEtc">면접 일정 조율</li>
                      </ul>
                      <p>
                        <small style="color:#E71414;">{{ inputError.intvAbleDay }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">면접 방식</th>
                    <td>
                      <template v-for="option in $gb.INTV_GB">
                        <KSARadioButton class="check-box mr-lg" name="intvGb" :label="option.label" v-model="createCorp.intvGb" :value="option.value" @change="optionData('intvGb')"/>
                      </template>
                      <p>
                        <small style="color:#E71414;">{{ inputError.intvGb }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">이력서 양식</th>
                    <td>
                      <p class="red mb-xs" v-if="createCorp.fileYn === 'Y'">※ ‘협회 이력서’ 양식 사용을 권장합니다.</p>
                      <KSARadioButton class="check-box mr-lg" label="협회 이력서" v-model="createCorp.fileYn" value="N" @change="resetFile('N')" />
                      <KSARadioButton class="check-box mr-lg" label="회사 이력서" v-model="createCorp.fileYn" value="Y" @change="resetFile('Y')" />
                      <p>
                        <small style="color:#E71414;">{{ inputError.fileYn }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr v-if="createCorp.fileYn === 'Y'">
                    <th class="mark">회사 이력서 양식 첨부</th>
                    <td class="text-box">
                      <div class="mb-xs">
                        <p class="red">* 첨부 전 반드시 확인해주세요!</p>
                        - 의도치 않게 개인정보가 노출될 수 있으므로 첨부하는 파일에 <span class="red">실제 개인정보가 입력되어 있는지 확인</span>해주세요.<br>
                        - 첨부된 파일로 인해 개인정보가 노출될 경우 책임은 첨부한 기업에 있음을 알려드립니다.<br>
                        - 파일명은 <span class="red">‘기업명_이력서양식’</span> 으로 첨부해 주세요.
                      </div>
                      <div class="grid file" v-for="attach in createCorp.corpResumeAttaches">
                        <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpResume" />
                        <KSAInput class="input icon" v-model="createCorpFileNameSize" placeholder="파일 선택" disabled />
                        <button class="delete" @click="removeFileCorpResume"><i></i></button>
                      </div>
                      <small>최대 200MB 까지 첨부 가능</small>
                      <p>
                        <small style="color:#E71414;">{{ inputError.corpResumeAttaches }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">모집인원</th>
                    <td>
                      <div class="grid half">
                        <KSAInputNumber v-model="createCorp.recruitCnt" @input="validateText('recruitCnt')" placeholder="0" maxLength="2" /> 명
                      </div>
                      <p>
                        <small style="color:#E71414;">{{ inputError.recruitCnt }}</small>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- e : 참가 신청 정보 -->
              <!-- s : 참가 신청 담당자 정보 -->
              <div class="table-form mt-sm">
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">참가 신청 담당자 정보</th>
                  </tr>
                  <tr>
                    <th class="mark">성명</th>
                    <td>
                      <KSAInput class="text-box" v-model="createCorp.chargeName" @input="validateText('chargeName')" maxLength="10" placeholder="성명을 입력하세요." />
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargeName }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">부서</th>
                    <td>
                      <KSAInput class="text-box" v-model="createCorp.chargeDepart" @input="validateText('chargeDepart')" maxLength="10" placeholder="부서를 입력하세요." />
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargeDepart }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">직위</th>
                    <td>
                      <KSAInput class="text-box" v-model="createCorp.chargeJob" @input="validateText('chargeJob')" maxLength="10" placeholder="직위를 입력하세요." />
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargeJob }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">회사 직통번호</th>
                    <td>
                      <!-- 20250924(ella): 회사 직통번호 밸리데이션 제거 -->
<!--                      <KSAInputGeneralPhoneNum class="text-box" label="" v-model="createCorp.chargeCompanyNum" @input="validateText('chargeCompanyNum')" placeholder="회사 직통번호를 입력하세요." />-->
                      <KSAInput class="text-box" v-model="createCorp.chargeCompanyNum" @input="validateText('chargeCompanyNum')" maxLength="200" placeholder="회사 직통번호를 입력하세요. ex) 02-1234-5678" />
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargeCompanyNum }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">휴대전화</th>
                    <td>
                      <KSAInputPhoneNum class="input" v-model="createCorp.chargePhoneNum" label="" @input="validateText('chargePhoneNum')" maxLength="200" placeholder="휴대폰 번호를 입력하세요."/>
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargePhoneNum }}</small>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th class="mark">이메일</th>
                    <td>
                      <KSAInput class="text-box" v-model="createCorp.chargeEmail" @input="validateText('chargeEmail')" maxLength="50" placeholder="이메일 주소를 입력하세요." />
                      <p>
                        <small style="color:#E71414;">{{ inputError.chargeEmail }}</small>
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
              <!-- e : 참가 신청 담당자 정보 -->
              <!-- s: 약관 동의 -->
              <div class="terms-wrap">
                <hr>
                <KSACheckBox label="기업정보 및 개인(담당자)정보의 수집 · 이용 · 제공 및 활용에 동의합니다." v-model="createCorp.agreePrivacyYn" /><span class="red">(필수)</span>
                <div class="terms-box">
                  1. 수집하는 기업정보 및 개인(담당자)정보 항목<br>
                  회사는 회사가 주최 및 주관하는 {{ mode === 'openRecruitment' ? '기업공채관' : '채용박람회' }}의 참가 신청, 채용 공고 등록을 위한 기업정보 확인 등을 위해 아래와 같은 기업정보 및 개인(담당자)정보를 수집하고 있습니다.<br><br>

                  - 기업정보 : 사업자등록번호, 기업명, 대표자명, 사업장소재지, 업종, 산업군, 기업형태, 창립연월, 사원수, 매출액, 상장여부, 홈페이지, 로고, 사업자등록증, 기업소개, 주요연혁, 기업 소개서 등<br>
                  - 개인(담당자)정보 : 성명, 부서, 직위, 회사 직통번호, 휴대전화번호, 이메일 등<br><br>


                  2. 정보의 이용 목적 및 제공 범위<br>
                  회사는 수집한 기업정보 및 개인(담당자)정보를 다음의 목적을 위해 활용합니다.<br><br>

                  - {{ mode === 'openRecruitment' ? '기업공채관' : '채용박람회' }} 채용 공고 등록 및 확인을 위한 기업의 정보 확인 목적<br>
                  - {{ mode === 'openRecruitment' ? '기업공채관' : '채용박람회' }} 참가 회원들에게 제공되는 채용 공고 노출을 위한 기업 정보의 제공 목적<br>
                  - 기업 홍보관의 기업정보 등록 및 확인을 위한 기업의 정보 확인 목적<br>
                  - 기업 홍보관의 이용 회원들이 확인할 수 있는 기업 정보의 제공 목적<br><br>

                  3. 정보 보유 및 이용기간<br>
                  회사는 수집한 기업정보 및 개인(담당자)정보를 이용목적이 달성된 후에는 정보를 관할 할 수 있는 기업회원탈퇴 시까지 보유하고 회원탈퇴 이후에는 해당 정보를 지체 없이 파기합니다.

                </div>
              </div>
              <!-- e: 약관 동의-->
            </div>
            <div class="btn-wrap space-between">
              <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel(ojfId)" />
              <KSAPrimaryButton text="다음" @click="saveCorp()" />
            </div>
          </div>
        </div>
        <!-- E : 강의 상세-->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.etc-box {
  display: inline-block;
  width: 200px;
}

.table-form {
  table {
    &.vertical {
      &.align-left {
        th {
          text-align: left;
          small {
            display: block;
            font-size: $font-size_xs;
            color: $gray_color;
            font-weight: normal;
          }
        }
      }
    }
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
  .disabled {
    cursor: default;
    background: $gray-regular_color;
    border-color: $gray-regular_color;
    color: #fff;
  }
}

.terms-wrap {
  margin: 20px 0;

  > .check-box:first-child {
    @include font-size_md;
  }

  hr {
    border: $border_line;
    margin: 20px 0;
  }

  .terms-box {
    height: 180px;
    overflow-y: auto;
    @include font-size_xs;
    background: $gray-thin_color;
    border: $border_line;
    padding: 20px;
    margin: 10px 0 40px;
  }
}

:deep(.error-focus),
:deep(.error-focus input) {
  outline: 2px solid #E71414 !important;
  border-color: #E71414 !important;
}
</style>